import { render, staticRenderFns } from "./CommercialBillOfLadingQrView.vue?vue&type=template&id=e577881e&scoped=true&"
import script from "./CommercialBillOfLadingQrView.vue?vue&type=script&lang=js&"
export * from "./CommercialBillOfLadingQrView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e577881e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
